import React, { useState, useEffect } from 'react';
import * as styled from './HomeworkSubmission.styled';
import HomeworkImageUploader from '../HomeworkImageUploader/HomeworkImageUploader';

const HomeworkSubmission = ({onSubmit, lessonId, getHomeworkText}) => {
  const [homeworkText, setHomeworkText] = useState('');
  const [homeworkImages, setHomeworkImages] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  useEffect(() => {
    const fetchHomeworkText = async () => {
      const text = await getHomeworkText(lessonId);
      if (text) {
        setHomeworkText(text.homeworkText);
        if(text.homeworkImages?.length > 0) {
          setHomeworkImages(text.homeworkImages)
        }
      }
    };

    fetchHomeworkText();
  }, [lessonId, getHomeworkText]);
  const handleImagesChange = (images) => {
    setHomeworkImages(images);
  };
  const handleTextChange = (e) => {
    setHomeworkText(e.target.value);
  };

  return (
    <styled.SubmissionWrapper>
      <styled.TextArea
        value={homeworkText}
        onChange={handleTextChange}
        placeholder="Виконайте ваше домашнє завдання тут"
      />
       <HomeworkImageUploader 
        images={homeworkImages}
        onImagesChange={handleImagesChange}
        lessonId={lessonId}
        onUploadingChange={setUploading}
      />
      <styled.SubmitButton
        disabled={uploading || submitting}
        onClick={async () => {
          setSubmitting(true);
          try {
            await onSubmit(homeworkText, homeworkImages);
          } finally {
            setSubmitting(false);
          }
        }}
      >
        {uploading ? 'Завантажуємо фото...' : 'Надіслати ДЗ'}
      </styled.SubmitButton>
    </styled.SubmissionWrapper>
  );
};

export default HomeworkSubmission;
